// extracted by mini-css-extract-plugin
export var divider = "style-module--divider--Vq1hq";
export var header = "style-module--header--z-dgL";
export var imgWrapper = "style-module--imgWrapper--isxY0";
export var localizationWrapper = "style-module--localizationWrapper--XxHX+";
export var root = "style-module--root--0ecLc";
export var textWrapper = "style-module--textWrapper--p9KaK";